import {
    Widget,
    Accordion,
    DropdownSelect,
    Expand,
    UISwiper,
    Input,
    PopupCalendar,
    DateSpinner,
    PopupExternal,
    PopupSelect,
    FormBox,
    Tab,
    SubTab,
    Tooltip,
    ToggleRadio,
    ScrollAnimation,
    WebNumpad,
    DeleteList,
    Lottie,
    Calculator,
    Range,
    SwipeToAction,
    Sortable,
    Counter,
    NumberRolling,
    Observer,
    Step,
    StepAccordion,
} from "./components";

const commonUiList = [
    {
        className: '.ui-step',
        classObject: Step,
    },
    {
        className: '.ui-step-accordion',
        classObject: StepAccordion,
    },
    {
        className: '.ui-observer',
        classObject: Observer
    },
    {
        className: '.ui-widget',
        classObject: Widget
    },
    {
        className: '.ui-accordion',
        classObject: Accordion
    },
    {
        className: '.ui-expand',
        classObject: Expand,
    },
    {
        className: '.ui-swiper',
        classObject: UISwiper
    },
    {
        className: '.ui-input[data-type="dateSpinner"]',
        classObject: DateSpinner,
    },
    {
        className: '.ui-input:not([data-type="dateSpinner"])',
        classObject: Input
    },
    {
        className: '.ui-calendar',
        classObject: PopupCalendar
    },
    {
        className: '.ui-popup',
        classObject: PopupExternal
    },
    {
        className: '.ui-dropdown',  // CHPFMTASK-1610 
        classObject: DropdownSelect
    },
    {
        className: '.ui-input select:not([data-type="dropdown"])',
        classObject: PopupSelect
    },
    {
        className: '.ui-formBox',
        classObject: FormBox
    },
    {
        className: '.ui-tab',
        classObject: Tab
    },
    {
        className: '.ui-subTab',
        classObject: SubTab
    },
    {
        className: '.ui-tooltip',
        classObject: Tooltip,
    },
    {
        className: '.ui-ToggleRadio',
        classObject: ToggleRadio,
    },
    {
        className: '[data-role="animation-group"]',
        classObject: ScrollAnimation,
    },
    {
        className: '.ui-webnumpad',
        classObject: WebNumpad,
    },
    {
        className: '.ui-deleteList',
        classObject: DeleteList
    },
    {
        className: '.ui-lottie',
        classObject: Lottie
    },
    {
        className: '.ui-calc',
        classObject: Calculator
    },
    {
        className: '.ui-range',
        classObject: Range
    },
    {
        className: '.ui-swipeAction',
        classObject: SwipeToAction
    },
    {
        className: '.ui-sortable',
        classObject: Sortable
    },
    {
        className: '.ui-counter',
        classObject: Counter
    },
    {
        className: '.ui-rolling',
        classObject: NumberRolling
    },
];

export default commonUiList;